import React from "react";

const ErrorMessages = ({ errorMessage }) => {
  const formattedDescription = errorMessage
    ?.split("\n")
    ?.filter(line => line.trim())
    ?.map((line, index) => {
      if (line?.startsWith("-")) {
        return <li key={index}>{line?.replace("-", "")?.trim()}</li>;
      } else {
        return <p key={index}>{line?.trim()}</p>;
      }
    });

  return (
    <div>
      {formattedDescription?.[0]}
      <ul style={{ padding: 0 }}>{formattedDescription?.slice(1)}</ul>
    </div>
  );
};

export default ErrorMessages;
